import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../root';
import { persistReducer } from 'redux-persist';
import { localAppStorage } from '../root/local-storage';

export type ApiInspectorItem = {
  id: string;
  endpoint?: string;
  url?: string;
  method?: string;
  request?: any;
  response?: any;
  error?: any;
  status: 'pending' | 'success' | 'error';
  duration?: number;
  route: string;
  timestamp: number;
};

type State = {
  requests: ApiInspectorItem[];
  enable: boolean;
};

const initialState: State = {
  enable: false,
  requests: [],
};

const slice = createSlice({
  name: 'apiInspector',

  initialState,

  reducers: {
    requestStarted: (state, action: PayloadAction<ApiInspectorItem>) => {
      if (!state.enable) return;

      state.requests.unshift(action.payload);

      if (state.requests.length > 200) {
        state.requests.pop();
      }
    },

    requestFinished: (
      state,
      action: PayloadAction<{
        id: string;
        response?: any;
        error?: any;
        duration: number;
      }>
    ) => {
      if (!state.enable) return;

      const item = state.requests.find((x) => x.id === action.payload.id);

      if (!item) return;

      item.response = action.payload.response;
      item.error = action.payload.error;
      item.duration = action.payload.duration;
      item.status = action.payload.error ? 'error' : 'success';
    },

    clearRequests: (state) => {
      state.requests = [];
    },

    toggleApiInspector: (state) => {
      state.enable = !state.enable;
    },

    setApiInspectorEnabled: (state, action: PayloadAction<boolean>) => {
      state.enable = action.payload;
    },
  },
});

export const {
  requestStarted,
  requestFinished,
  clearRequests,
  toggleApiInspector,
  setApiInspectorEnabled,
} = slice.actions;

export const apiInspectorReducer = slice.reducer;

export const getApiInspectoSliceState = (rootState: RootState): State =>
  rootState['apiInspector'];

export const getApiInspectorSelector = createSelector(
  getApiInspectoSliceState,
  (state) => state
);

export const getApiInspectorEnabled = createSelector(
  getApiInspectoSliceState,
  (state) => state.enable
);

const apiInspectorPersistConfig = {
  key: 'apiInspector',
  storage: localAppStorage,
  whitelist: ['enable'],
};
export const persistedApiInspectorReducer = persistReducer(
  apiInspectorPersistConfig,
  apiInspectorReducer
);
